<template>
  <div class="instruction">
    <div class="instruction-header">
      <span class="instruction-header-title"> {{ $t('App') }} </span>
    </div>
    <article class="instruction-steps">
      <div class="instruction-steps-topline">
        <div class="instruction-steps-topline-icon">
          <img src="/assets/instruction/download.webp" class="instruction-steps-topline-icon-image" alt="download" width="121" height="126" loading="lazy" fetchpriority="auto">
        </div>
        <span class="instruction-steps-topline-title"> {{ $t('To add an application icon to the smartphone home screen, do the following:') }} </span>
      </div>
      <div class="instruction-steps-content">
        <div class="instruction-steps-content-item">
          <div class="instruction-steps-content-item-counter">
            <span class="instruction-steps-content-item-counter-text"> 1 </span>
          </div>
          <p class="instruction-steps-content-item-text"> {{ $t(`Click on 'Advanced Features' at the bottom center`) }} </p>
        </div>
        <div class="instruction-steps-content-item">
          <div class="instruction-steps-content-item-counter">
            <span class="instruction-steps-content-item-counter-text"> 2 </span>
          </div>
          <p class="instruction-steps-content-item-text"> {{ $t(`Select 'Home screen' from the menu`) }} </p>
        </div>
      </div>
    </article>
    <div class="instruction-content">
      <div class="instruction-content-container">
        <img src="/assets/instruction/iphone/phone-1/bitmap1.jpg"
             v-if="jpgImages1Load"
             decoding="sync"
             loading="lazy"
             width="280"
             height="558"
             class="instruction-content-container-image"
             @load="imageLoaded('jpgImages1Load', true)"
             @error="imageLoaded('jpgImages1Load', false)"
        >
        <img src="/assets/instruction/iphone/phone-2/bitmap.jpg"
             v-if="jpgImages2Load"
             decoding="sync"
             loading="lazy"
             width="280"
             height="558"
             class="instruction-content-container-image"
             @load="imageLoaded('jpgImages2Load', true)"
             @error="imageLoaded('jpgImages2Load', false)"
        >
        <div class="instruction-content-container-circle">
          <div class="first"></div>
          <div class="second"></div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

  export default {
    name: 'Iphone',
    mounted () {
      this.$nextTick(() => window.scrollTo(0, 97));
    },
    data () {
      return {
        pngImages1Load: true,
        pngImages2Load: true,
        jpgImages1Load: true,
        jpgImages2Load: true
      }
    },
    metaInfo () {
      return {
        title: this.$t('How to install Korzyna.com app on iPhone'),
        meta: [{vmid: 'description', description: this.$t('How to install Korzyna.com app on iPhone')}]
      }
    },
    methods: {
      imageLoaded (type, success) {
        this[type] = success
      }
    }
  }
</script>

<style scoped lang="scss">
  @keyframes show-phone {
    0% { opacity: 1; }
    40% { opacity: 1; }
    50% { opacity: 0; }
    90% { opacity: 0; }
    100% { opacity: 1; }
  }
  @keyframes hide-phone {
    0% { opacity: 0; }
    40% { opacity: 0; }
    50% { opacity: 1; }
    90% { opacity: 1; }
    100% { opacity: 0; }
  }
  @keyframes circle-move {
    0% { bottom: 40px; left: -10px; }
    40% { bottom: 40px; left: -10px; }
    50% { bottom: 177px; left: 205px; }
    90% { bottom: 177px; left: 205px; }
    100% { bottom: 40px; left: -10px; }
  }
  @keyframes circle-animation {
    from {
      top: 32px;
      left: 32px;
      width: 0;
      height: 0;
      opacity: 1;
    }
    to {
      top: 0;
      left: 0;
      width: 64px;
      height: 64px;
      opacity: 0;
    }
  }

  .instruction {
    display: flex;
    flex-direction: column;

    &-header {
      height: 40px;

      position: relative;

      display: flex;
      justify-content: center;
      align-items: center;

      background-image: url('/assets/instruction/header/pille-riin-priske-9-el-mi-ar-pj-vq-unsplash.webp');
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;

      &::before {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        margin: auto;
        content: '';

        background: rgba(0, 0, 0, .3);
      }

      &-title {
        font-weight: bold;
        letter-spacing: .1px;
        color: #fff;

        z-index: 1;
      }
    }

    &-steps {
      padding: 0 10px;
      margin: 10px 0;

      &-topline {
        margin-bottom: 20px;

        display: flex;
        align-items: center;

        &-icon {
          min-width: 50px;
          height: 50px;

          margin-right: 10px;

          display: flex;
          justify-content: center;
          align-items: center;

          background-color: #11bb2e;
          border-radius: 50%;

          &-image {
            width: 20px;
            height: 20px;
          }
        }

        &-title {
          font-size: 15px;
          font-weight: 600;
          letter-spacing: .1px;
          color: #111;
        }
      }

      &-content {
        padding-left: 10px;

        &-item {
          margin-bottom: 10px;
          position: relative;

          border-radius: 10px;
          border: 1px solid #ebebeb;
          background-color: #fff;

          &-counter {
            width: 30px;
            height: 30px;

            position: absolute;
            top: 0;
            left: -10px;
            margin: auto;

            display: flex;
            justify-content: center;
            align-items: center;

            background-color: #f5f5f5;
            border-radius: 50%;

            &-text {
              font-weight: bold;
              letter-spacing: .1px;
              color: #11bb2e;
            }
          }

          &-text {
            padding: 9px 30px;
            margin: 0;

            font-size: 15px;
            letter-spacing: .1px;
            color: #111;
          }
        }
      }
    }

    &-content {
      padding: 0 10px;
      position: relative;

      display: flex;
      align-items: center;
      flex-direction: column;

      &-container {
        width: 280px;
        height: 558px;

        position: relative;

        &-image {
          width: 100%;
          height: 100%;

          position: absolute;
          top: 0;
          right: 0;
          left: 0;
          bottom: 0;
          margin: auto;

          user-select: none;

          &:nth-child(1) {
            opacity: 1;
            animation: show-phone 7s ease infinite;
          }

          &:nth-child(2) {
            opacity: 0;
            animation: hide-phone 7s ease infinite;
          }
        }

        &-circle {
          width: 64px;
          height: 64px;

          position: absolute;
          right: 0;
          left: -10px;
          bottom: 40px;
          margin: auto;

          animation: circle-move 7s cubic-bezier(.77, 0, .175, 1) infinite;

          & div {
            position: absolute;
            border: 4px solid #11bb2e;
            border-radius: 50%;
            animation: circle-animation 2s ease-out infinite;

            &:nth-child(2) {
              animation-delay: -1s;
            }
          }
        }
      }
    }
  }
</style>
